import script from "./TestimonyDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./TestimonyDetail.vue?vue&type=script&setup=true&lang=js"

import "./TestimonyDetail.vue?vue&type=style&index=0&id=711bffab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-711bffab"]])

export default __exports__